import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const pageRoutes: RouteRecordRaw[] = [
  {
    path: '/pages',
    name: 'pages',
    component: () => import('@/modules/pages/views/PageListView.vue'),
    meta: {
      permission: PERMISSIONS.CONTENT.VIEW,
      projectScoped: true,
    },
  },
]
